import { styled, Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { ROUTES } from './routes';

export const App = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'background.paper',
      }}
    >
      {/* Main Content Area */}
      <MainContent>
        <Routes>
          {ROUTES.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Routes>
      </MainContent>
    </Box>
  );
};

const MainContent = styled(Box)`
  && {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
  }
`;
